<template>
  <Container type="card-full">
    <div class="search">
      <div class="search_box">
        <!-- <div class="searchItem">
          <div class="label" style="width: 180px;">项目名称(不支持模糊查询):</div>
          <div class="field">
            <el-input v-model.trim="query.projectname" clearable></el-input>
          </div>
          
        </div> -->
        <div class="searchItem">
          <div class="label">项目编号</div>
          <div class="field">
            <el-input v-model.trim="query.projectcode" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="search_btn">
            <el-button type='primary' @click="search">查询</el-button>
          </div>
          <p style="color: red; margin-left: 8px" v-if="!query.projectname || !query.projectcode">请输入查询条件后查询</p>
        </div>
      </div>
      <div class="view-container" v-if="Object.keys(project).length > 0">
        <div class="view-box">
          <div class="view-row">
            <div class="view-field">
              <div class="view-label" style="font-size: 16px;color:##303133">项目名称：</div>
              <div class="view-value" style="font-size: 16px;color:##303133">{{ project.projectname }}</div>
            </div>
            <div class="view-field">
              <div class="view-label" style="font-size: 16px;color:##303133">采购人：</div>
              <div class="view-value" style="font-size: 16px;color:##303133">{{ project.pcomfullname }}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label" style="font-size: 16px;color:##303133">项目员：</div>
              <div class="view-value" style="font-size: 16px;color:##303133">{{ project.ausername }}</div>
            </div>
            <div class="view-field">
              <div class="view-label" style="font-size: 16px;width:140px;color:##303133">竞价开始时间：</div>
              <div class="view-value" style="font-size: 16px;color:##303133">{{ project.prsbjbegtime | longDate }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <vxe-table
        border
        show-header-overflow
        show-overflow
        highlight-hover-row
        :align="allAlign"
        :data="dialogList">
        <vxe-table-column type="seq" title="序号" width="60">
        </vxe-table-column>
        <vxe-table-column type="seq" :title="prsName.gys" width="320">
          <template v-slot="{ row }">
              {{ row.origin[0].pbrcomname }}
          </template>
        </vxe-table-column>
        <vxe-table-column field="sex" title="报价人" width="140">
          <template v-slot="{ row }">
              {{ row.origin[0].psuname }}
          </template>
        </vxe-table-column>
        <vxe-table-column field="sex" width="260" :title="`报价(${projectQuotationmodeflg.three})`">
          <template v-slot="{ row }">
            <!-- {{ row.origin.length }} -->
            <div v-for="j in row.origin" :key="j.pbrid" style="display: flex;" class="bjview-list-item">
                  <div class="item-index"  v-if="+row.prsbjtimes > 1">第{{ j.pbtseq }}轮</div>
                    <div class="item-price" v-if="+row.projectquotationmode === 1">￥{{ j.pbramt | qfwVal }}元(
                      <amount :money="String(j.pbramt)" v-if="j.pbramt" />)
                    </div>
                    <div class="item-price" v-else>{{ j.pbrpricerate }}%</div>
            </div>
          </template>
        </vxe-table-column>
        
        <vxe-table-column field="sex" title="报价时间" width="220">
        <template v-slot="{ row }">
            <div v-for="j in row.origin" :key="j.pbrid" class="bjview-list-item">
                <div class="item-index">{{ j.pbrtime | newDate }}</div>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column field="name" title="最后操作ip">
          <template v-slot="{ row }">
              {{  row.origin[0].ip ? row.origin[0].ip.replace('::ffff:', '') : '' }}
            </template>
        </vxe-table-column>
        <!-- <vxe-table-column field="name" title="MAC地址" >
          <template v-slot="{ row }">
              {{  row.origin[0].mac }}
            </template>
        </vxe-table-column> -->
    </vxe-table>
  </Container>
</template>
<script>
import request from '@/utils/request'
import MenuBtn from "../common/menuBtn"
import vggrid from '../common/vggrid'
import utils from '../../assets/js/utils'
import dayjs  from 'dayjs'
import amount from '../common/amount'
export default {
  name: 'pbrIndex',
  data() {
    return {
      menuid: this.$route.query.menuid,
      btn: {},
      list: [],
      cols: [
        { type: 'index', fieldtype: 'I', title: '行号', calculExpr: '', width: 80 },
        { field: 'pbrcomid', fieldtype: 'C', title: '最后操作ip', calculExpr: '', addNewRowFlg: false },
      ],
      comform: false,
      project: {},
      com: {},
      query: {
        total: 0,
        limit: 20,
        offset: 0,
        projectcode: '',
        projectname: ''
      },
      roles: [],
      dialogList: []
    }
  },
  async activated() {
    await this.getBJList()
  },
  mounted() {
  },
  watch: {
    async '$route'() {
      this.getPageList()
    }
  },
  components: { MenuBtn, vggrid },
  methods: {
    async getModel(d) {
      let res = await request({
        method: 'get',
        url: '/xmgl/project/findProjectById',
        params: { projectid: d[0].projectid }
      })
      this.project = res
    },
    async getBJList() {
      let model = {}
      this.project = {}
      let res = await request({
        url: '/xmgl/pbr/getPbrListByIndex',
        method: "get",
        params: this.query
      })
      // if (+this.project.projectpricelistflag === 0 && +this.$store.getters.loginUser.comtype === 3) {
      //   res = res.filter(e => {
      //     return +e.pbrcomid === +this.$store.getters.loginUser.comid
      //   })
      // }
      res.map(e => {
        e.psuoffertime = dayjs(e.psuoffertime).format('YYYY-MM-DD HH:mm:ss SSS')
      })
      if (res.length > 0) {
        await this.getModel(res)
      }
      this.dialogList = this.Sortbycomid(res)
      console.log(this.dialogList, '-qq')
    },
    Sortbycomid(beforeData) {
      let tempArr = [], afterData = []
      for (let i = 0; i < beforeData.length; i++) {
        if (tempArr.indexOf(beforeData[i].pbrcomid) === -1) {
          this.project.projectquotationmode = beforeData[i].projectquotationmode
          this.project.prsflg = beforeData[i].prsflg
          afterData.push({
            pbrcomid: beforeData[i].pbrcomid,
            projectname: beforeData[i].projectname,
            projectcode: beforeData[i].code,
            prsbjtimes: beforeData[i].prsbjtimes,
            projectquotationmode: beforeData[i].projectquotationmode,
            origin: [beforeData[i]]
          });
          tempArr.push(beforeData[i].pbrcomid);
        } else {
          for (let j = 0; j < afterData.length; j++) {
            if (afterData[j].pbrcomid == beforeData[i].pbrcomid) {
              afterData[j].origin.push(beforeData[i]);
              // afterData[j].origin.sort((a,b) => {
              //   return Number(a.pbramt) - Number(b.pbramt)
              // })
              break;
            }
          }
        }
      }
      console.log(afterData)
      return afterData
    },
    init() {
      this.query = {
        total: 0,
        limit: 20,
        offset: 0,
        comtype: ''
      }
    },
    async cellClick(row) {
      this.com = row.row
    },
    async viewProject(row) {
      this.com = row.row
      this.$router.push({ name: 'comView', params: { comid: this.com.comid, innerbtn: this.btn.inner } })
    },
    async pagechange(page) {
      this.query.offset = page.pageSize * (page.currentPage - 1)
      this.query.limit = page.pageSize
      this.getPageList()
    },
    search() {
      this.query.offset = 0
      this.getBJList()
    },
  },
  filters: {
    longDate(value) {
      return value ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : ''
    },
    newDate(value) {
      return dayjs(value).format('YYYY-MM-DD HH:mm:ss SSS')
    },
    qfwVal(value) {
      if (!!value && +value > 0) {
        return utils.comdify(value)
      } else {
        return value
      }
    },
  },
  components: { amount },
  computed: {
    projectQuotationmodeflg() {
      if (+this.project.projectquotationmode === 1) {
        return {
          one: '报价',
          two: '金额报价',
          three: '金额'
        }
      }
      if (+this.project.projectquotationmode === 2) {
        return {
          one: '上浮率报价',
          two: '最高上浮率报价',
          three: '上浮率'
        }
      }
      if (+this.project.projectquotationmode === 3) {
        return {
          one: '下浮率报价',
          two: '最高下浮率报价',
          three: '下浮率'
        }
      }
      if (+this.project.projectquotationmode === 4) {
        return {
          one: '折扣率报价',
          two: '最低折扣率报价',
          three: '折扣率'
        }
      }
      return {
        one: '报价',
        two: '金额报价',
        three: '金额'
      }
    },
    prsName() {
      // 竞拍方案，比选文件
      if (+this.project.prsflg === 1 || +this.project.prsflg === 3) {
        return {
          gys: '竞价单位',
          filename: '竞价方案'
        }
      }
      else if (+this.project.prsflg === 4 || +this.project.prsflg === 5) {
        return {
          gys: '竞拍单位',
          filename: '竞拍方案'
        }
      }
      else if (+this.project.prsflg === 6) {
        return {
          gys: '比选单位',
          filename: '评审文件'
        }
      } else {
        return {
          gys: '竞价单位',
          filename: '竞价方案'
        }
      }
    }
  }
}
</script>
<style lang="scss">
</style>
